module.exports = __webpack_public_path__ + "img/197.e2c8b226.jpg";